import { render, staticRenderFns } from "./TwoByOne.vue?vue&type=template&id=7d69347f&"
import script from "./TwoByOne.vue?vue&type=script&lang=js&"
export * from "./TwoByOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports